"use client";
import React, { useState } from "react";
import ReactDom from "react-dom";
import styles from "./map.module.scss";

import { Spinner } from "react-bootstrap";
import Map from "./Map";
import { useJsApiLoader } from "@react-google-maps/api";
import { MAP_API_KEY } from "config/config";

type LocationType = {
  lat: number;
  lng: number;
};

interface MapContainerProps {
  location?: Partial<LocationType>;
  setLatLng?: (latlng: LocationType) => void;
  address?: string;
  setAddress?: (add: string) => void;
  setClose?: (close: boolean) => void;
  isEdit?: boolean;
  searchBar?: boolean;
}

const MapContainer: React.FC<MapContainerProps> = ({
  location = {},
  setLatLng = () => { },
  address = "",
  setAddress = () => { },
  setClose = () => { },
  isEdit = false,
  searchBar = true,
}) => {
  const [libraries] = useState<Array<"places">>(["places"]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: MAP_API_KEY,
    // googleMapsApiKey: process.env.MAP_API_KEY as string,
    libraries: libraries,
  });

  const modalRoot = document.getElementById("modal");
  if (!modalRoot) return null;

  return ReactDom.createPortal(
    <div className={styles.mapContainer}>
      <div className={styles.background} onClick={() => setClose(false)}></div>
      <div className={styles.map}>
        {!isLoaded ? (
          <Spinner />
        ) : (
          <Map
            location={location}
            setLatLng={setLatLng}
            address={address}
            setAddress={setAddress}
            searchBar={searchBar}
            isEdit={isEdit}
            setClose={setClose}
          />
        )}
      </div>
    </div>,
    modalRoot
  );
};

export default React.memo(MapContainer);
